import { ONBOARDING_SYNC_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { OnboardingStep, OnboardingSteps, SyncView, TeamInvites } from './general';
export const SyncFirstTimeView = () => React.createElement(SyncView, { pre: React.createElement(OnboardingSteps, { currentStep: OnboardingStep.Team }), title: ONBOARDING_SYNC_COPY.READY_SHORTLY },
    React.createElement("p", null, ONBOARDING_SYNC_COPY.MAIN_DIALOG),
    React.createElement("p", null, ONBOARDING_SYNC_COPY.ADD_TEAM_INFO),
    React.createElement(TeamInvites, null));
